import type { AICXConfig } from './config';

/**
 * SDK 인스턴스 내부 상태
 * 외부에 노출되지 않는 내부 관리용 타입
 */

export interface AICXInternalState {
  /**
   * SDK 초기화 여부
   * 중복 초기화 방지 체크
   */
  initialized: boolean;

  /**
   * 저장된 설정
   * 초기화 시 전달된 설정 저장
   */
  config: AICXConfig | null;

  /**
   * 챗봇 UI 상태 추적
   */
  isOpen: boolean;

  /**
   * iframe 엘리먼트 참조
   * DOM 참조
   * */
  iframe: HTMLIFrameElement | null;

  /**
   * 컨테이너 DOM 참조
   * */
  container: HTMLDivElement | null;
}

/**
 * 초기 상태 팩토리
 */
export function createInitialState(): AICXInternalState {
  return {
    initialized: false,
    config: null,
    isOpen: false,
    iframe: null,
    container: null,
  };
}
